export const COVERAGE_I18N = 'proof_video_coverage'
export const PERIOD_I18N = `${COVERAGE_I18N}.period`
